import React from 'react';
import ReactDOM from 'react-dom';

import {serviceWorker} from 'core/service-worker';

import {AppStoreProvider} from 'hooks/app-store';
import {LanguagesProvider} from 'hooks/languages';
import {AccountStoreProvider} from 'hooks/account-store';

import {GlobalStyle} from 'styles/global-style';

import {Apps} from './apps';
import {mergeStores} from 'utils';

const Stores = mergeStores(
    AccountStoreProvider,
    AppStoreProvider,
    LanguagesProvider
);

ReactDOM.render((
    <Stores>
        <Apps/>
        <GlobalStyle/>
    </Stores>
), document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
